import { useAppSelector } from 'src/store/hooks'
import { getBingoRoomJackpotPrize } from 'store/modules/bingo/selectors'
import type { JackpotCurrency } from 'store/modules/jackpotsFromProviders/types'
import { extractBingoRoomId, parseJackpotSafe } from 'utils/jackpot'

type GameWithTypeAndCode = {
  type?: string | null
  code: string
}

type UseBingoJackpotTickerResult = {
  hasBingoJackpot: boolean
  bingoJackpotAmount: number | undefined
  bingoJackpotCurrency: JackpotCurrency | null
}

export function useBingoJackpotTicker(game: GameWithTypeAndCode): UseBingoJackpotTickerResult {
  const isBingo = game.type === 'bingo'
  const roomId = extractBingoRoomId(game.code)
  const bingoRoomJackpot = useAppSelector((state) => getBingoRoomJackpotPrize(state, isBingo ? roomId : ''))
  const bingoJackpotAmount = parseJackpotSafe(bingoRoomJackpot?.jackpotPrize)
  const rawCurrency = bingoRoomJackpot?.currency
  const bingoJackpotCurrency: JackpotCurrency | null = rawCurrency === 'GC' || rawCurrency === 'SC' ? rawCurrency : null
  const hasBingoJackpot = isBingo && bingoJackpotAmount != null && bingoJackpotCurrency != null

  return { hasBingoJackpot, bingoJackpotAmount, bingoJackpotCurrency }
}
